export function NoCoachesFound() {
  return (
    <div className="col-span-full my-12 flex flex-col items-center gap-2 text-center">
      <h1 className="text-2xl font-bold">No Coaches Found</h1>
      <p className="text-muted-foreground">Try adjusting your search</p>
    </div>
  )
}